module.exports = __webpack_public_path__ + "static/media/dream-gardens-lahore.91abaed7.jpg";